import React from 'react'
import Hero from './Hero/Hero'
import Features from './Features/Features'
import PartnersList from './PartnersList/PartnersList'
import Contact from './Contact/Contact'
import Page from '../../components/Page/Page'

const ImportFromChina = () => {
    return (
        <Page title='CML | Import from China'>
            <Hero />
            <PartnersList />
            <Features />
            <Contact />
        </Page>
    )
}

export default ImportFromChina